import { useEffect, useMemo } from 'react';
import { useItemRelationshipsStore } from '../../stores/prioritization/itemRelationshipsStore';
import type { RelationshipGraph } from '../../lib/itemRelationshipFlags';

/** The workspace relationship graph, loaded once if no page has loaded it yet. */
export function useRelationshipGraph(): RelationshipGraph {
  const groups = useItemRelationshipsStore((s) => s.groups);
  const memberships = useItemRelationshipsStore((s) => s.groupMemberships);
  const edges = useItemRelationshipsStore((s) => s.edges);
  const neverLoaded = useItemRelationshipsStore((s) => !s.syncState.lastSyncAt && !s.syncState.isLoading);
  const fetchFromSupabase = useItemRelationshipsStore((s) => s.fetchFromSupabase);

  useEffect(() => {
    if (neverLoaded) void fetchFromSupabase().catch(() => {});
  }, [neverLoaded, fetchFromSupabase]);

  return useMemo(() => ({ groups, memberships, edges }), [groups, memberships, edges]);
}
